import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { getStore } from '@/store'
import context from '@/context'
import { allowErrorDialog } from '@/utils/fetch'

export const openTwoFactorDialog = (onAction) => {
  context.api.auth.generateTwoFactorTokensForCurrentUser(true, allowErrorDialog)
    .then(is2FARequired => {
      if (is2FARequired) {
        getStore().dispatch(dialogActions.openDialog({
          dialogType: dialogTypes.twoFactorAuthentication,
          onAction
        }))
      } else {
        onAction()
      }
    })
    .catch(() => onAction())
}



// WEBPACK FOOTER //
// ./src/utils/twoFactorHelper.js